<div cdkTrapFocus>
  <div class="modal-header">
    <h3 class="modal-title" i18n="@@disabledServiceTitle">Service Unavailable</h3>
    <button
      type="button"
      class="close"
      aria-label="Close"
      ngbAutoFocus
      (click)="activeModal.dismiss()"
    >
      <span aria-hidden="true"><i class="ico-cancel modal_exit_cross"></i></span>
    </button>
  </div>
  <div class="modal-body">
    <p i18n="@@TheInvokedUser">
      The invoked user does NOT have a credit card stored in their Lightning profile.
    </p>
    <div class="modal-footer">
      <button
        type="button"
        appButton="small"
        aria-label="Close"
        i18n-aria-label
        i18n="@@modalFlightFareOK"
        (keydown.enter)="activeModal.close()"
        (keydown.space)="activeModal.close()"
        (click)="activeModal.close()"
      >
        Close
      </button>
    </div>
  </div>
</div>
